import { render, staticRenderFns } from "./musicbanner.vue?vue&type=template&id=1290a8ed&"
import script from "./musicbanner.vue?vue&type=script&lang=js&"
export * from "./musicbanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports